"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography")); // eslint-disable-next-line react/prop-types


var GroupHeading = function GroupHeading(_ref) {
  var children = _ref.children,
      innerProps = _ref.innerProps;
  return _react["default"].createElement("div", {
    style: {
      alignItems: 'center',
      color: 'grey',
      display: 'flex',
      height: 24,
      paddingLeft: 16
    }
  }, _react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    noWrap: true
  }, innerProps, {
    style: {
      textTransform: 'none'
    },
    variant: "overline"
  }), children));
};

var _default = GroupHeading;
exports["default"] = _default;